import React from 'react'
import { getSvg } from '@src/containers/UtmGenerator/helpers'
import { TitleComponent } from '@src/components/UtmGenerator'
import { Features } from '@src/data/UtmGenerator'

import * as Styled from './Error.styled'

const Error = () => {
  return (
    <Styled.Section>
      <div className="container">
        <Styled.Header>
          <TitleComponent text="Генератор составляет UTM-метки без ошибок" />
        </Styled.Header>
        <Styled.List>
          {Features.map(item => (
            <Styled.Item key={item.id}>
              <Styled.Icon>{getSvg(item.icon)}</Styled.Icon>
              <p>{item.text}</p>
            </Styled.Item>
          ))}
        </Styled.List>
      </div>
    </Styled.Section>
  )
}

export default Error
